export const WRAPPER_CSS_ID = 'bb-breadcrumbs';
export const BREADCRUMBS_CSS_CONTAINER = 'bb-breadcrumbs-container';
export const BREADCRUMBS_LEVELONE_CLASS_NAME = 'bb-breadcrumbs__levelOne';
export const BREADCRUMBS_LEVELTWO_CLASS_NAME = 'bb-breadcrumbs__levelTwo';
export const BREADCRUMBS_LAST_VISIBLE_CLASS_NAME = 'bb-breadcrumbs__lastVisible';
export const BREADCRUMBS_INVISIBLE_CLASS_NAME = 'bb-breadcrumbs__invisible';
export const BREADCRUMBS_RETURNLINK_CLASS_NAME = 'bb-breadcrumbs__homeLink';
export const BREADCRUMBS_LEVELTWO_TEXT = `${BREADCRUMBS_LEVELTWO_CLASS_NAME}__text`;
